import React, { useState, useEffect } from 'react';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import Text from './Text';
import PaymentMethod from './PaymentMethod';
import RedcatImage from './RedcatImage';
import '../styles/stripe.css';
import { useAppSelector } from '../app/hooks';
import { OrderingSelectors, OrderingConstants } from 'polygon-ordering';

const { getStripeCurrency, getGatewayType } = OrderingSelectors;
const { PAYMENT_GATEWAY_TYPES, PAYMENT_METHOD } = OrderingConstants;

const PaymentMethodApplePay = () => {
  const gatewayType = useAppSelector(getGatewayType);
  const [applePayEnabled, setApplePayEnabled] = useState<boolean | null>(false);
  // eslint-disable-next-line
  const stripe = gatewayType === PAYMENT_GATEWAY_TYPES.STRIPE ? useStripe() : null;
  // eslint-disable-next-line
  const elements = gatewayType === PAYMENT_GATEWAY_TYPES.STRIPE ? useElements() : null;
  const stripeCurrency = useAppSelector(getStripeCurrency);

  useEffect(() => {
    if (gatewayType !== PAYMENT_GATEWAY_TYPES.STRIPE || !stripe || !elements) {
      return;
    }

    const pr = stripe.paymentRequest({
      country: 'AU', // TODO: fix to avoid stripe overseas fees
      currency: stripeCurrency,
      total: {
        label: 'Payment Total:',
        amount: 0,
      },
    });

    pr.canMakePayment().then(result => {
      if (result?.applePay) {
        setApplePayEnabled(true);
      }
    });
  }, [gatewayType, stripe, elements]);

  // For tyro enabling apple pay if device and browser are compatible
  useEffect(() => {
    if (
      gatewayType === PAYMENT_GATEWAY_TYPES.TYRO &&
      (window as Window & typeof globalThis & { ApplePaySession: any })?.ApplePaySession
    ) {
      setApplePayEnabled(true);
    }
  }, []);

  return (
    <>
      {applePayEnabled && (
        <PaymentMethod
          method={PAYMENT_METHOD.APPLE_PAY}
          right={
            <div style={styles.buttonContainer}>
              <div style={styles.markContainer}>
                <RedcatImage
                  imagePath="https://assets.redcatcloud.com.au/webordering/Apple_Pay_Mark_RGB_041619.svg"
                  imageStyle={{ objectFit: 'contain' }}
                  size={54}
                />
              </div>
            </div>
          }
          subtitle={<Text themeKey="paymentMethodUnavailableReason">&nbsp;</Text>}
        />
      )}
    </>
  );
};

const styles: Styles = {
  buttonContainer: {
    position: 'relative',
  },
  markContainer: {
    position: 'absolute',
    top: -27,
    left: 'auto',
    right: 1,
  },
};

export default PaymentMethodApplePay;
